import {
  BsCheckCircleFill,
  BsExclamationCircleFill,
  BsExclamationTriangleFill,
  BsFillTrash3Fill,
  BsFillXCircleFill,
  BsHandThumbsUpFill,
  BsHourglassSplit,
  BsXCircleFill,
} from 'react-icons/bs';
import { ClearanceStatusEnum, ConnectionRequestStatus, FacilityStatusEnum } from '../../../api';
import { ConnectionCombinedStatusEnum } from '../ConnectionRequestsTable/ConnectionCombinedStatusEnum';

interface ConnectionStatusBadge {
  status: ConnectionRequestStatus;
  className?: string;
  userIsProvider?: boolean;
}

interface CombinedStatusBadge {
  status: ConnectionCombinedStatusEnum;
  className?: string;
  userIsProvider?: boolean;
}

export const ConnectionStatusBadge = ({
  status,
  className,
  userIsProvider,
}: ConnectionStatusBadge) => {
  return (
    <>
      {status === ConnectionRequestStatus.ACCEPTED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-green-2 fs-12 ${
            className ?? ''
          }`}
        >
          <BsHandThumbsUpFill className={`me-1 align-bottom`} />
          {userIsProvider ? 'You Accepted' : 'Provider Accepted'}
        </div>
      )}

      {status === ConnectionRequestStatus.REJECTED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-danger fs-12 ${
            className ?? ''
          }`}
        >
          <BsXCircleFill className={`me-1 align-bottom`} />
          {userIsProvider ? 'You Rejected' : 'Provider Rejected'}
        </div>
      )}

      {status === ConnectionRequestStatus.CANCELED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-danger fs-12 ${
            className ?? ''
          }`}
        >
          <BsFillTrash3Fill className={`me-1 align-bottom`} />
          Canceled
        </div>
      )}

      {status === ConnectionRequestStatus.PENDING_RESPONSE && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-neutral-300 fs-12 ${
            className ?? ''
          }`}
        >
          <BsHourglassSplit className="align-bottom me-1" />
          {userIsProvider ? 'Pending Your Response' : 'Pending Provider’s Response'}
        </div>
      )}

      {status === ConnectionRequestStatus.PENDING_SEND && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-secondary fs-12 ${
            className ?? ''
          }`}
        >
          Pending Send
        </div>
      )}
    </>
  );
};

export const ConnectionCombinedStatusBadge = ({
  status,
  className,
  userIsProvider,
}: CombinedStatusBadge) => {
  return (
    <>
      {/*Connection Statuses*/}
      {status === ConnectionRequestStatus.PENDING_SEND && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-secondary fs-12 ${
            className ?? ''
          }`}
        >
          Pending Send
        </div>
      )}
      {status === ConnectionRequestStatus.PENDING_RESPONSE && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-neutral-300 fs-12 ${
            className ?? ''
          } text-break`}
        >
          <BsHourglassSplit className="align-bottom me-1" />
          {userIsProvider ? 'Pending Your Response' : "Pending Provider's Response"}
        </div>
      )}
      {status === ConnectionRequestStatus.REJECTED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-danger fs-12 ${
            className ?? ''
          }`}
        >
          <BsXCircleFill className={`me-1 align-bottom`} />
          {userIsProvider ? 'You Rejected' : 'Provider Rejected'}
        </div>
      )}
      {status === ConnectionRequestStatus.CANCELED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal bg-danger fs-12 ${
            className ?? ''
          }`}
        >
          <BsFillTrash3Fill className={`me-1 align-bottom fs-14`} />
          Canceled
        </div>
      )}
      {/*Clearance Statuses*/}
      {status === ClearanceStatusEnum.PENDING_CLEARANCE && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal badge-warning-light fs-12 ${
            className ?? ''
          }`}
          style={{ whiteSpace: 'nowrap' }}
        >
          <BsExclamationTriangleFill className={`me-1 align-bottom text-warning-dark fs-14`} />
          <span>Pending Clearance</span>
        </div>
      )}
      {status === ClearanceStatusEnum.NOT_CLEARED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal fs-12 bg-red-100 ${
            className ?? ''
          }`}
        >
          <BsFillXCircleFill className="align-bottom me-1 fs-14" />
          <span>Not Cleared</span>
        </div>
      )}
      {/*Facility Statuses*/}
      {status === FacilityStatusEnum.PENDING_APPROVAL && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal badge-warning-light fs-12 ${
            className ?? ''
          }`}
        >
          <BsExclamationCircleFill className="align-bottom me-1 fs-14 text-warning-dark" />
          Pending Facility Approval
        </div>
      )}
      {status === FacilityStatusEnum.APPROVED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal fs-12 bg-primary-muted bg-green-2 ${
            className ?? ''
          }`}
        >
          <BsCheckCircleFill className="align-bottom me-1" />
          Completed
        </div>
      )}

      {status === FacilityStatusEnum.DENIED && (
        <div
          className={`d-inline-flex align-items-center badge rounded-pill fw-normal fs-12 bg-red-100 ${
            className ?? ''
          }`}
        >
          <BsFillXCircleFill className="align-bottom me-1 fs-14" />
          Facility Declined
        </div>
      )}
    </>
  );
};
